<template>
  <div class="footer">
    <div class="footerContent">
      <small>© Copyright {{ getYear }} │ ma-ya's CREATE All rights reserved.<br>This has been generated by Vue.js.</small>
      <div class="logo">
        <a href="https://myscreate.com/" target="_blank" rel="noopener"><img src='../assets/img/logo.svg' alt="ma-ya's CREATE"></a>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    getYear(){
      return new Date().getFullYear();
    }
  }
}
</script>

<style scoped lang='scss'>
@use '../assets/scss/variables.scss';
.footer {
  display: flex;
  margin-top: 5rem;
  margin-bottom: 1.5rem;
  .footerContent {
    margin-left: auto;
    display: flex;
  }
  .logo {
    margin-left: 1rem;
    img {
      width: 70px;
      height: auto;
    }
  }
  small {
    font-size: 10px;
    text-align: right;
    line-height: 1.75;
    letter-spacing: 1px;
  }
}
</style>
